var Education = "教育";
var Enterprise = "企业";
var CompanyType = {
	"Company type": "公司类型",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "联邦政府",
	"Government - State & local": "州和地方政府",
	"Non-profit": "非营利性机构",
	"Self employed": "自雇",
	"Small-medium business": "中小型企业",
	"Start-up": "初创公司",
	"Not applicable": "不适用"
};

export { Education, Enterprise, CompanyType as default };
